import { FC, HTMLAttributes } from 'react';
import CloseIcon from '@mui/icons-material/Close';

import { IDataTestId } from '@custom';
import BackButtonContent from '@3.0/Buttons/BackButton/BackButtonContent';
import '@3.0/Buttons/ButtonGeneralStyles.css';
import './TitleBarButton.css';
import cn from 'utils/cn';

type TProps = {
  hide: boolean;
  variant: 'close' | 'back';
  buttonProps: HTMLAttributes<HTMLButtonElement> & IDataTestId;
};

const TitleBarButton: FC<TProps> = ({ variant, hide, buttonProps }) => {
  return (
    <button
      {...buttonProps}
      className={cn(
        hide
          ? 'dn'
          : `mume-${variant}-button tw:box-border h-inherit tw:cursor-pointer button--titlebar tw:w-12 tw:flex tw:items-center tw:justify-center`,
        buttonProps?.className
      )}
      data-testid={buttonProps['data-testid'] || `${variant}-title-bar-button`}
      onClick={buttonProps.onClick}
      type="button"
      disabled={hide}
    >
      {variant === 'close' && <CloseIcon className="tw:text-2xl" />}
      {variant === 'back' && <BackButtonContent />}
    </button>
  );
};

export default TitleBarButton;
